import {debounce} from 'lodash';
import React, {useCallback} from 'react';
import {DateRangePicker} from 'rsuite';

const DrugFilters = ({filters, setFilters, setPagination}) => {
  const handleSearchChange = useCallback(
    debounce(value => {
      setFilters(prev => ({...prev, search: value}));
      setPagination(prev => ({...prev, pageIndex: 1})); // Reset to first page on search
    }, 500), // Delay API calls by 500ms
    [setFilters, setPagination]
  );

  const handleInputChange = e => {
    handleSearchChange(e.target.value);
  };

  const handleDateChange = newValue => {
    if (newValue?.length === 2) {
      const [start, end] = newValue;

      const startDate = new Date(start);
      const endDate = new Date(end);

      // Remove time portion
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);

      // Format date correctly using `toLocaleDateString`
      const formatDate = date => date.toLocaleDateString('en-CA'); // 'YYYY-MM-DD' format

      const fromDate = formatDate(startDate);
      const toDate = formatDate(endDate);
      // Format as 'YYYY-MM-DD'

      setFilters(prev => ({
        ...prev,
        order_date_from: fromDate,
        order_date_to: toDate
      }));
    } else {
      setFilters(prev => ({
        ...prev,
        order_date_from: '',
        order_date_to: ''
      }));
    }
  };

  return (
    <div className='filters-container' style={{display: 'flex', gap: '20px'}}>
      <div className='input-group rounded' style={{width: '250px', height: '40px'}}>
        <input type='search' className='form-control rounded' aria-label='Search drugs' placeholder='Search...' defaultValue={filters.search} onChange={handleInputChange} style={{height: '40px'}} />
        <span className='input-group-text border-0 bg-transparent p-0'>
          <i className='bi bi-search' style={{color: '#1b5a90', width: '20px', height: '20px', marginLeft: '10px'}}></i>
        </span>
      </div>
      {/* <input style={{width: '200px', height: '40px'}} defaultValue={filters.orderDate} className='form-control rounded' type='date' onChange={handleDateChange} /> */}
      <div className='input-group rounded' style={{width: '300px', height: '40px'}}>
        <DateRangePicker
          // value={value}
          onChange={handleDateChange}
          placeholder='Select Dates'
          appearance='default'
          className='w-100 custom-date-picker'
          format='dd-MM-yyyy'
          shouldDisableDate={date => false}
        />
      </div>{' '}
    </div>
  );
};

export default DrugFilters;
